module.exports = __webpack_public_path__ + "media/images/icons/icon-x-round-9078a7e0a4baffd58b0b145a079d1266.svg";